import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "button-modal-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        "active-validate": false,
        headerTitle: _ctx.$t('document.reglementaire.modal.header'),
        "is-pop-up-table": true,
        noPaddingTop: false,
        withoutBotNav: true,
        class: "modal-choix-site",
        onCancel: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CheckBox, {
            checked: _ctx.typesSelectionnees.length === _ctx.typesDocuments.length,
            label: _ctx.$t('typeSelection.selectionner.tout'),
            partiel: _ctx.typesSelectionnees.length > 0 && _ctx.typesSelectionnees.length !== _ctx.typesDocuments.length,
            onClickCheck: _ctx.addAllTypes
          }, null, 8, ["checked", "label", "partiel", "onClickCheck"]),
          _createElementVNode("div", {
            "aria-label": _ctx.$t('document.reglementaire.modal.header'),
            class: "wrap",
            role: "group"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typesDocuments, (document) => {
              return (_openBlock(), _createElementBlock("div", {
                key: document.id,
                class: "margin-10px",
                onClick: ($event: any) => (_ctx.addType(document))
              }, [
                _createVNode(_component_CheckBox, {
                  checked: _ctx.typesSelectionnees.some(type => type.code === document.code),
                  label: _ctx.getLibelleDocuement(document)
                }, null, 8, ["checked", "label"])
              ], 8, _hoisted_2))
            }), 128))
          ], 8, _hoisted_1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ButtonBlue, {
              disabled: _ctx.typesSelectionnees.length === 0,
              onClick: _ctx.valider,
              text: _ctx.$t('app.bottom.navigation.button.confirm'),
              class: "button-confirm btn",
              name: "confirm"
            }, null, 8, ["disabled", "onClick", "text"])
          ])
        ]),
        _: 1
      }, 8, ["headerTitle", "onCancel"])
    ]),
    _: 1
  }))
}